import { UnitOfMeasureTypes, UomText } from '../enumerations/unit-of-measure-type';
import { ILocalizedDescription } from '../interfaces/dtos/ILocalizedDescription';
import { store } from '../redux/configure-store';

// TODO set local culture when get POS configuration in session-storage.
export const LOCAL_CULTURE = 'en-US';
export const LOCAL_ISO_CURRENCY_CODE = 'USD';
export const LOCAL_CURRENCY_SYMBOL = '$';

// PosConfig call was not implemented in Selling servie yet and default UOM in SE is KGM now
export const getDefaultWeightUnitOfMeasure = (): string => {
  return (
    store.getState().touchPoint.touchPointConfiguration.defaultWeighUnitOfMeasure ||
    UnitOfMeasureTypes.Libra
  );
};

export const getDefaultWeightUomText = (): string => {
  const defaultUOM = getDefaultWeightUnitOfMeasure();
  return UomText[defaultUOM];
};

export const getDescriptionAccordingToStoreCulture = (
  descriptions?: ILocalizedDescription[],
): string => {
  let description: string | undefined;
  if (descriptions && descriptions.length) {
    if (descriptions.length === 1) {
      description = descriptions[0].value;
    }
    const desc = descriptions.find(o => o.culture === LOCAL_CULTURE);
    description = desc ? desc.value : descriptions[0].value;
  }
  return description || '';
};
